/**
 * Trạng thái cho phép sử dụng chức năng
 */
export default {
    Add: 1,
    Merge: 2,
    Refuse: 4,
}